<template>
    <div class="modalDOLog">
        <b-modal :no-close-on-backdrop="true"
                 @hidden="formatData"
                 id="modal-DO-Log"
                 title="Add New Delivery Batch"
                 modal-class="modal-create-do-delivery"
                 hide-footer :centered="true"
                 v-model="modals.createDO.open">
            <b-form class="formV2">
                <b-row>
                    <b-col md="2">
                        <div class="pl-20 pr-20 pt-20">
                            <gofix-form-input-date
                                    v-model="modals.createDO.data.log_time"
                                    label="DO Date">
                            </gofix-form-input-date>
                        </div>
                    </b-col>
                    <b-col md="3">
                        <div class="pr-20 pt-20">
                            <gofix-form-input label="Supplier Do Ref. Number" v-model="modals.createDO.data.do_ref_number"></gofix-form-input>
                        </div>
                    </b-col>
                    <b-col md="7">
                        <div class="pr-20 pt-20">
                            <b-row class='mb-25'>
                                <div class="action actionFloat d-flex font-weight-bold">
                                    <div class="title">Attachments</div>
                                    <b-button @click="removeAttachment">
                                        <div class="tooltip">Delete</div>
                                        <svg height="20" viewBox="0 0 512 512" width="20"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"
                                                  fill="#999999"/>
                                        </svg>
                                    </b-button>
                                    <b-button class='pr-20' type="button" @click="editAttachment(-1)">
                                        <div class="tooltip">Create</div>
                                        <svg height="20" viewBox="0 0 304.223 304.223" width="20"
                                             xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                                             xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <path d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"
                                                fill="#999999"/>
                                            <path d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"
                                                  fill="#999999"/>
                                        </svg>
                                    </b-button>
                                </div>
                            </b-row>

                            <b-row class='mb-20' v-if="modals.createDO.data.attachments.length" align-h="end">
                                <b-col class="col-4 mb-2" v-for="(attachment,index) in modals.createDO.data.attachments" :key="index">
                                    <div class="attachmentInfo">
                                        <div class="checkbox">
                                            <b-form-checkbox class="uniform" :value="index" v-model="modals.createDO.attachmentDelete"></b-form-checkbox>
                                        </div>
                                        <img v-if="checkShowIcon(attachment.type)" class="icon" :src="attachment | iconFile(icons)" with="24" height="24" alt="icon-file">
                                        <div class="name">{{attachment.image_file_title || attachment.name}}</div>
                                        <div class="edit"><button @click="editAttachment(index, attachment)" type="button" class="buttonAttachments buttonAttachments__unset"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.71 5.63126C21.1 6.02127 21.1 6.65127 20.71 7.04127L18.88 8.87126L15.13 5.12126L16.96 3.29126C17.1468 3.10401 17.4005 2.99878 17.665 2.99878C17.9295 2.99878 18.1832 3.10401 18.37 3.29126L20.71 5.63126ZM3 20.5013V17.4613C3 17.3213 3.05 17.2013 3.15 17.1013L14.06 6.19126L17.81 9.94127L6.89 20.8513C6.8 20.9513 6.67 21.0013 6.54 21.0013H3.5C3.22 21.0013 3 20.7813 3 20.5013Z" fill="#999999"/></svg></button></div>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col md="12">
                        <div class="scrollTableDO">
                            <b-table :fields="tableFieldsItem" :items="deliveredData" class="addDOLogTable" fixed>
                                <template slot="index" slot-scope="data">
                                    {{data.index + 1}}
                                </template>
                                <template slot="item_description" slot-scope="data">
                                    {{ data.item.item_description }} - <span class="color-red">{{ data.item.item_description_two }}</span>
                                </template>
                                <template slot="delivered_quantity" slot-scope="data">
                                    <gofix-form-input-number
                                            class="m-0"
                                            v-bind:class="{gofixInputError : data.item.error}"
                                            @change="()=>{
                                                if(data.item.delivered_quantity > (data.item.quantity - data.item.qty_delivered)){
                                                    data.item.error = true;
                                                }else{
                                                    if(data.item.delivered_quantity < 0){
                                                        data.item.delivered_quantity = null
                                                    }
                                                    data.item.error = false
                                                }
                                            }"
                                            label="Qty Delivered"
                                            :includeThousandsSeparator="false"
                                            v-model="data.item.delivered_quantity">
                                        <template #gofixInput:text:after-desc  v-if="data.item.error">
                                            <p class="desc color-error">The Qty Delivered exceeds the Qty Ordered.</p>
                                        </template>
                                    </gofix-form-input-number>
                                </template>
                            </b-table>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="text-right d-block pr-3">
                <gofix-button label="SUBMIT" @click="saveDOLog" noBorder :loading="modals.createDO.loading"></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" title="import file" ref="modal-Import-attachments" id="modal-Contract-Attachments" hide-footer v-model="modals.attachment.open">
            <b-form class="formV2">
                <gofix-form-input label="File Title" v-model="modals.attachment.image_file_title"></gofix-form-input>
                <b-form-group :label="modals.attachment.filename">
                    <b-form-file ref="file-input" v-model="modals.attachment.fileAttachment" ></b-form-file>
                </b-form-group>
                <b-button-group class="text-right d-block">
                    <gofix-button label="SUBMIT" @click="addAttachment" noBorder :loading="modals.attachment.loading"></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    export default {
        name: 'modalDOlog',
        data () {
            return {
                modals:{
                    createDO:{
                        open: false,
                        loading: false,
                        data:{
                            log_time: new Date(),
                            do_ref_number: null,
                            attachments: [],
                        },
                        fieldsItem: [
                            {
                                key: 'index',
                                label: 'S/N',
                                thClass: 'text-center',
                                tdClass: 'text-center',
                                isActive: 1,
                                thStyle: 'width: 70px',
                            },
                            {
                                key: 'sor_code',
                                label: 'SOR',
                                thClass: 'text-center',
                                tdClass: 'text-center',
                                isActive: 1
                            },
                            {
                                key: 'item_description',
                                label: 'Description',
                                thClass: 'text-left td-description',
                                tdClass: 'text-left td-description',
                                isActive: 1,
                                thStyle: 'width: 150px',
                            },
                            {
                                key: 'property',
                                label: 'Location',
                                isActive: 1,
                                thStyle: 'width: 150px',
                            },
                            {
                                key: 'jobs',
                                label: 'Jobs',
                                placeholder: 'search',
                                isActive: 1,
                                thStyle: "width: 70px",
                            },
                            {
                                key: 'quantity',
                                label: 'Qty',
                                thStyle: 'width: 70px',
                                thClass: 'text-right',
                                tdClass: 'text-right',
                                isActive: 1
                            },
                            {
                                key: 'qty_delivered',
                                label: 'Delivered  To Date',
                                thClass: 'text-right',
                                tdClass: 'text-right',
                                thStyle: 'width: 120px',
                                isActive: 1
                            },
                            {
                                key: 'line_status',
                                label: 'Completion Status',
                                thClass: 'text-left',
                                tdClass: 'text-left',
                                thStyle: 'width: 150px',
                                isActive: 1
                            },
                            {
                                key: 'delivered_quantity',
                                label: '',
                                thClass: 'text-left',
                                tdClass: 'text-left',
                                thStyle: 'width: 260px',
                                isActive: 1
                            }
                        ],
                        attachmentDelete: [],
                    },
                    attachment:{
                        open:false,
                        loading: false,
                        filename: "Click Browse to upload file",
                        fileAttachment:null,
                        image_file_title: null,
                        edit: 0
                    },
                },
                icons: {
                    'application': {
                        'word': 'word.png',
                        'excel': 'excel.png',
                        'pdf': 'pdf.png',
                    },
                    'image': 'image.png',
                    'text': 'notepad.png',
                },
              woTax: null
            }
        },
        watch : {
            "modals.attachment.fileAttachment": function(val, old) {
                this.modals.attachment.filename = 'Click Browse to upload file';
                if (val) {
                    let extensionAccept = ['csv','xls', 'xlsx', 'docx', 'doc', 'pdf', 'txt', 'jpeg', 'jpg', 'png', 'gif'];
                    let extensionArray = val.name.split('.');
                    let extension = extensionArray[extensionArray.length - 1].toLowerCase();
                    if(!extensionAccept.includes(extension)) {
                        this.$refs['file-input'].reset()
                        return this.$alertNotification("File format is incorrect. Please select a .csv, .xls, .xlsx, .docx, .doc, .pdf, .txt, .jpeg, .jpg, .png, .gif file!", "warning");
                    }
                    this.modals.attachment.filename = val.name
                }
            },
            "OrderItem.supplier_id": function(val, old) {
              this.getWOTax()
            },
            "modals.createDO.data.log_time": function(val, old) {
              this.getWOTax()
            },
        },
        created() {
          if(this.OrderItem){
            this.getWOTax()
          }
        },
        filters: {
            iconFile(val, icons) {
                let path = 'img/';
                let arrTemp = val.type.split('/');
                let extension = val.name.split('.')[1];
                if(arrTemp && arrTemp.length == 2) {
                    let type = arrTemp[0];
                    if(type == 'application') {
                        let key = 'pdf';
                        if(['docx', 'doc'].includes(extension)) key = 'word';
                        if(['xls', 'xlsx', 'csv'].includes(extension)) key = 'excel';
                        return `${path}${icons['application'][key]}`;
                    }
                    return `${path}${icons[type]}`;
                }
            }
        },
        computed: {
            ...mapGetters({
                OrderItem: 'OrderController/Item'
            }),
            tableFieldsItem(){
                let fields = this.modals.createDO.fieldsItem.map(element => {
                    if(this.OrderItem.order_type !== "PWO" && element.key === "jobs"){
                        return false
                    }
                   return element
                });

                return fields;
            },
            deliveredData(){
                let data = [];
                if(!this.OrderItem.get_order_line_item) return data;
                for(let i = 0;i<this.OrderItem.get_order_line_item.length;i++){
                    data.push({
                        id: this.OrderItem.get_order_line_item[i].id,
                        sor_code: this.OrderItem.get_order_line_item[i].sor ? this.OrderItem.get_order_line_item[i].sor.sor_code : null,
                        item_description: this.OrderItem.get_order_line_item[i].item_description_one,
                        item_description_two: this.OrderItem.get_order_line_item[i].item_description_two,
                        property: this.OrderItem.get_order_line_item[i].property ? this.OrderItem.get_order_line_item[i].property.name : null,
                        jobs: this.OrderItem.get_order_line_item[i].maintenance_program_id ? this.OrderItem.get_order_line_item[i].jobs_completed_count + " / " + this.OrderItem.get_order_line_item[i].jobs_all_count : '--',
                        quantity: this.OrderItem.get_order_line_item[i].quantity,
                        qty_delivered: this.OrderItem.get_order_line_item[i].qty_delivered,
                        line_status: this.OrderItem.get_order_line_item[i].line_status,
                        delivered_quantity: null,
                        error: false,
                        _rowVariant: (this.OrderItem.get_order_line_item[i].line_status === "Invoiced" || this.OrderItem.get_order_line_item[i].qty_delivered === this.OrderItem.get_order_line_item[i].quantity) ? 'Warning' : null,
                    })
                }
                return data;
            }
        },
        methods: {
            checkShowIcon(val) {
                if(!val) return false;
                let arrTemp = val.split('/');
                if(!arrTemp || arrTemp.length < 2 || !this.icons[arrTemp[0]]) return false;
                return true;
            },
            formatData(){
                this.modals.createDO.data = {
                    log_time: new Date(),
                    do_ref_number: null,
                    attachments: [],
                };
            },
            saveDOLog(){
                //Check data
                if(!this.modals.createDO.data.log_time){
                    return this.$alertNotification("Please enter DO date", "danger");
                }

                let bug = 1;
                for(let i = 0;i<this.deliveredData.length;i++){
                    if(parseFloat(this.deliveredData[i].delivered_quantity)){
                        bug = 0
                    }
                    if(this.deliveredData[i].error){
                        bug = 2
                    }
                }
                if(bug === 2){
                    return this.$alertNotification("The Qty Delivered exceeds the Qty Ordered.", "danger");
                }
                if(bug === 1){
                    return this.$alertNotification("Please enter a 'Qty delivered'", "danger");
                }

                let data = {
                    do_number : "DO-" + (this.OrderItem.client_contract ? this.OrderItem.client_contract.abbreviation: null) +"-" + moment().format("DDMM-"),
                    order_id : this.$route.params.id,
                    line_items : this.deliveredData,
                    log_time: moment(this.modals.createDO.data.log_time).format("YYYY-MM-DD"),
                    do_ref_number: this.modals.createDO.data.do_ref_number,
                    contract_id: this.OrderItem.client_contract ? this.OrderItem.client_contract.id : null,
                    attachments: this.modals.createDO.data.attachments
                };

                if(this.modals.createDO.loading) return;
                this.modals.createDO.loading = true;

                this.$store.dispatch("DeliveryOrderController/createDOLog",data)
                    .then(response => {
                        this.$alertNotification(this.$notificationV2('adding', 'delivery_log'));
                        this.modals.createDO.loading = false;
                        this.modals.createDO.open = false;
                        this.$store.dispatch("OrderController/getItem",this.$route.params.id);
                        this.$emit('reloadorder');
                    })
                    .catch(err => {
                        this.modals.createDO.loading = false;
                        this.$alertNotification("Can't create DO log", "danger");
                    })
            },
            openModal(){
                this.modals.createDO.open = true;
            },
            addAttachment(){
                if(this.modals.attachment.edit >= 0){
                    if(this.modals.attachment.filename == 'Click Browse to upload file' && !this.modals.attachment.fileAttachment) {
                        return this.$alertNotification("Please select a file", "danger");
                    }

                    if(this.modals.attachment.fileAttachment) {
                        this.modals.attachment.fileAttachment.image_file_title = this.modals.attachment.image_file_title
                        this.modals.createDO.data.attachments[this.modals.attachment.edit] = this.modals.attachment.fileAttachment
                    } else {
                        this.modals.createDO.data.attachments[this.modals.attachment.edit].image_file_title = this.modals.attachment.image_file_title
                    }
                    this.modals.attachment.image_file_title = null;
                    this.modals.attachment.fileAttachment = null;
                    this.modals.attachment.open = false;
                } else {
                    if(!this.modals.attachment.fileAttachment) {
                        return this.$alertNotification("Please select a file", "danger");
                    }

                    this.modals.attachment.fileAttachment.image_file_title = this.modals.attachment.image_file_title
                    this.modals.createDO.data.attachments.push(this.modals.attachment.fileAttachment);
                    this.modals.attachment.fileAttachment = null;
                    this.modals.attachment.open = false;
                }
            },
            removeAttachment(){
                for(let item of this.modals.createDO.attachmentDelete){
                    this.modals.createDO.data.attachments.splice(item, 1);
                }
                this.modals.createDO.attachmentDelete.length = [];
            },
            editAttachment(id, item = null){
                this.modals.attachment.edit = id;
                this.modals.attachment.image_file_title = null;
                this.modals.attachment.filename = 'Click Browse to upload file';
                if(item) {
                    this.modals.attachment.image_file_title = item.image_file_title || null;
                    this.modals.attachment.filename = item.image_file_name || item.name
                }
                this.modals.attachment.open = true;
            },
          getWOTax(){
              
          }
        }
    }
</script>